import { FormGroup } from '@angular/forms';
import { FilterNodeComponent, FilterNodeFormModel } from '@shared/components/filter/filter-node/filter-node.component';
import { FilterNode } from '@shared/models/types/advanced-filter-input';
import { FilterNodeType } from '@shared/models/types/types.generated';
import { Injectable } from '@angular/core';
import { isUnaryOperator } from '@shared/utils/utils';

@Injectable()
export class FilterNodeService {
  public mapToFilterNode<T>(formGroup: FormGroup<FilterNodeFormModel<T>>): FilterNode<T> {
    const v = formGroup.value;
    const children = formGroup.controls.children?.controls;

    const filterNode: FilterNode<T> = {
      type: v.type,
    };

    if (children.length > 0) {
      filterNode.children = children.map((node) => this.mapToFilterNode(node));
    }

    if (v.value) {
      filterNode.value = v.value && {
        key: v.value.key,
        operator: v.value.operator,
        value: v.value.value,
      };
    }

    return filterNode;
  }

  public mapToFormGroup<T>(filterNode: FilterNode<T>): FormGroup<FilterNodeFormModel<T>> {
    const type = filterNode.type;
    const valueRequired = type === FilterNodeType.Leaf && !isUnaryOperator(filterNode.value?.operator);
    const nodeGroup = FilterNodeComponent.createNodeGroup<T>(type, valueRequired);

    if (type !== FilterNodeType.Leaf && filterNode.children.length > 0) {
      filterNode.children.forEach((node) => nodeGroup.controls.children.push(this.mapToFormGroup<T>(node)));
    } else if (type === FilterNodeType.Leaf) {
      nodeGroup.controls.value.patchValue({
        key: filterNode.value.key,
        operator: filterNode.value.operator,
        value: filterNode.value.value,
      });
    }

    return nodeGroup;
  }
}
